import {SDrawerOrModal, SGeneralForms, SMessage} from "shj-components";
import {getBizTypes} from "@/services/callCenter";
import {useSetState} from "ahooks";
import React, {useEffect, useState} from "react";
import AllowcateWorkerModal from "@/components/AllowcateWorkerModal";
import {batchAssignDesigner, queryTrackPlan} from "@/services/saleOpServices.ts";
import {Form} from "antd";

export const DispatchDesignerModal = (props: any) => {
  const {
    open,
    onClose,
    reload
  } = props
  const [form] = Form.useForm()
  const [state, setState] = useSetState<any>({
    bizTypeList: [],
    changeDispatcherOpen: false,
    bizTypeName: '',
    bizType: '',
    loading: false,
  })
  const [filterList, setFilterList] = useState<Array<any>>([]);

  useEffect(() => {
    if (open) {
      getOption()
      form.resetFields()
    }
  }, [open])

  const getOption = () => {
    setState({loading: true})
    getBizTypes().then(res => {
      setState({bizTypeList: res})
    }).finally(() => setState({loading: false}))
  }

  const onOk = () => {
    form.validateFields().then(values => {
      queryTrackPlan({clueIds: props.clueIds, bizType: values.bizType})
        .then(res => {
          if(!res.result){
            const tipStr = res.clueIds?.map(clueId => `【线索ID ${clueId}】`).join(', ')
            setFilterList(res.clueIds || []);
            SMessage.confirm({
              title: '不符合条件提示',
              content: `${tipStr} 之下无商机，不可执行改派设计师，是否继续改派其他有商机的线索？否，关闭弹窗；是，继续改派有商机的线索，忽略无商机的线索。`,
              okText: '是',
              cancelText: '否',
              onOk: () => {
                setState({changeDispatcherOpen: true, bizType: values.bizType})
                onClose()
              }
            })
          } else {
            setFilterList([]);
            setState({changeDispatcherOpen: true, bizType: values.bizType})
            onClose()
          }
        })
    })
  }

  return <>
    <SDrawerOrModal
        mode={'modal'}
        open={open}
        width={500}
        title={'选择批量改派设计师类型'}
        onCancel={onClose}
        onOk={onOk}
        okText={'下一步'}
        loading={state.loading}
    >
      <SGeneralForms
          layout={'vertical'}
          formConfig={{form}}
          configs={[{
            formItem: [{
              spanCol: 24,
              label: '需求标签',
              name: 'bizType',
              type: 'select',
              required: true,
              rules: [{
                required: true,
                message: '需求标签不能为空'
              }],
              comConfig: {
                options: state.bizTypeList,
                fieldNames: {label: 'description', value: 'key'},
                onChange: (_,  option) => {
                  setState({ bizTypeName: option.description })
                }
              }
            }]
      }]}/>
    </SDrawerOrModal>
    {state.changeDispatcherOpen &&
        <AllowcateWorkerModal isEditTitle={'改派'} isListOperation={true}
                              buttonKey={'ASSIGN_DESIGNER'}
                              title={`批量改派${state.bizTypeName}设计师`}
                              reload={reload}
                              searchQuery={{}}
                              isBatch={true}
                              isMultiple={true}
                              assignApi={batchAssignDesigner}
                              submitQuery={{bizType: state.bizType}}
                              editId={props.clueIds}
                              open={state.changeDispatcherOpen}
                              onClose={() => setState({changeDispatcherOpen: false})}/>}
  </>
}